import * as React from 'react';
import ActionList, { ActionListItem } from '@able/react/dist/ActionList';
import { Application } from '@applications/order-tracker';
import { Links, Components } from '@telstra-connect/order-tracker/activity-tracking';
import Grid from '@able/react/dist/Grid';
import Column from '@able/react/dist/Column';
import SectionHeader from '@able/react/dist/SectionHeader';
import Surface from '@able/react/dist/Surface';
import { HelpAndSupport, OrderDetailsSections } from '../../../../config/order-tracker-new-common/constants';
import { generateElementId } from '@applications/order-tracker/utils';

const onFAQClick = (): void => {
  Application.tracker.trackLink(
    Components.orderDetailsPage, Links.orderTrackerTile.viewFAQLink);
}

const onSubmitEnquiry = (): void => {
  Application.tracker.trackLink(
    Components.orderDetailsPage,
    Links.orderDetails.newEnquiryButton);
}

const HelpAndSupportOrderDetails = () => {
  return (
    <div
      id={generateElementId(OrderDetailsSections.HelpAndSupport)}
      data-testid={generateElementId(OrderDetailsSections.HelpAndSupport)}
    >
      <Surface
        background="materialBasePrimary"
        cornerRadius="cornerRadiusNone"
        interactive={false}
        variant="SurfaceFlat"
      >
        <Grid padding={false}>
          <Column cols={12} vxs={12} bsm={12} bmd={5} blg={12}>
            <SectionHeader
              title={HelpAndSupport.helpAndSupport}
              headingElement="h2"
              variantLevel="Level1"
            />
            <ActionList variant="Simple" topDivider={false}>
              <ActionListItem
                label={HelpAndSupport.faq}
                element="a"
                variantPassedFromParent="Simple"
                href={HelpAndSupport.faqRoute}
                events={{ onClick: () => onFAQClick() }}
              />
              <ActionListItem
                label={HelpAndSupport.submitEnquiry}
                element="a"
                href={HelpAndSupport.submitEnquiryRoute}
                variantPassedFromParent="Simple"
                events={{ onClick: () => onSubmitEnquiry() }}
              />
            </ActionList>
          </Column>
        </Grid>
      </Surface>
    </div>
  )
}

export default HelpAndSupportOrderDetails;
